export const FormInitialValues = value => ({
  subscriptionNote: value,
});
